// @flow
import { authenticatedFetch, unauthenticatedFetch } from '../../../api/request';

export default async function setNotificationSettingsAllEmail(
    enabled: boolean,
    token: string
) {
    console.log('settingSettings', token);

    if (token) {
        return await unauthenticatedFetch(`/public/v5/emailSettings/all`, {
            method: 'PUT',
            body: JSON.stringify({
                enabled,
                token
            })
        });
    }

    return await authenticatedFetch(`/v5/notifications/settings/setAllEmail`, {
        method: 'PUT',
        body: JSON.stringify({
            enabled
        })
    });
}
